import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navState: [],
mobileNavShow: false,
    // baseURL:'https://www-admin.xktech.com/prod-api',
    // baseURL:'http://192.168.7.18:820',
    // baseURL:'en.xktech.com',
    baseURL:'https://en.xktech.com/prod-api',
    currentPath:"",
    

},
  mutations: {
    updateNavState(state, data) {
      const arrTemp = [...state.navState];
      arrTemp[data.index] = data.value;   //改变index的值
      for (let i = data.index+1; i < arrTemp.length - 1; i++) {  //遍历当前层级的下一层子级
        arrTemp[i] = -1;  //把初始值设为-1 折叠
      }
      state.navState = arrTemp;   //新生成的数组放回原数组
    },
    foldNav(state) {  //折叠
      const arrTemp = [];
      for (let i = 0; i < state.navState.length; i++) {
        arrTemp.push(-1);
      }
      state.mobileNavShow = false;
      state.navState = arrTemp;
    },
    unFoldNav(state){   //展开
      state.mobileNavShow = true;
    },
    updateCurrentPath(state,data){
      state.currentPath = data;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js